/**
 * Couleurs des rôles utilisateurs
 * Utilisées dans les matrices d'accès et badges de rôle
 *
 * @module admin/roles
 */

export const ROLE_COLORS = {
  // Rôles application (Brydge)
  appAdmin: {
    main: '#d32f2f',
    dark: '#b71c1c',
    light: '#ef5350',
  },
  appCollaborator: {
    main: '#9c27b0',
    dark: '#7b1fa2',
    light: '#ba68c8',
  },

  // Rôles entreprise (clients)
  companyAdmin: {
    main: '#1976d2',
    dark: '#1565c0',
    light: '#42a5f5',
  },
  companyUser: {
    main: '#388e3c',
    dark: '#2e7d32',
    light: '#66bb6a',
  },

  // Fallback
  default: {
    main: '#757575',
    dark: '#616161',
    light: '#9e9e9e',
  },
};

/**
 * Retourne la couleur d'un rôle par son identifiant
 * @param {string} role - Identifiant du rôle (AppAdmin, CompanyUser, etc.)
 * @return {Object} Objet contenant main, dark et light
 */
export const getRoleColor = (role) => {
  const roleMap = {
    AppAdmin: ROLE_COLORS.appAdmin,
    AppCollaborator: ROLE_COLORS.appCollaborator,
    CompanyAdmin: ROLE_COLORS.companyAdmin,
    CompanyUser: ROLE_COLORS.companyUser,
  };

  return roleMap[role] || ROLE_COLORS.default;
};
